import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_SALES_INVOICES_REQUEST = 'GET_SALES_INVOICES_REQUEST';
export const GET_SALES_INVOICES_SUCCESS = 'GET_SALES_INVOICES_SUCCESS';
export const GET_SALES_INVOICES_ERROR = 'GET_SALES_INVOICES_ERROR';

export const GET_SALES_INVOICE_REQUEST = 'GET_SALES_INVOICE_REQUEST';
export const GET_SALES_INVOICE_SUCCESS = 'GET_SALES_INVOICE_SUCCESS';
export const GET_SALES_INVOICE_ERROR = 'GET_SALES_INVOICE_ERROR';

export const CREATE_SALES_INVOICE_REQUEST = 'CREATE_SALES_INVOICE_REQUEST';
export const CREATE_SALES_INVOICE_SUCCESS = 'CREATE_SALES_INVOICE_SUCCESS';
export const CREATE_SALES_INVOICE_ERROR = 'CREATE_SALES_INVOICE_ERROR';

export const UPDATE_SALES_INVOICE_REQUEST = 'UPDATE_SALES_INVOICE_REQUEST';
export const UPDATE_SALES_INVOICE_SUCCESS = 'UPDATE_SALES_INVOICE_SUCCESS';
export const UPDATE_SALES_INVOICE_ERROR = 'UPDATE_SALES_INVOICE_ERROR';

export const CHANGE_STATUS_SALES_INVOICE_REQUEST = 'CHANGE_STATUS_SALES_INVOICE_REQUEST';
export const CHANGE_STATUS_SALES_INVOICE_SUCCESS = 'CHANGE_STATUS_SALES_INVOICE_SUCCESS';
export const CHANGE_STATUS_SALES_INVOICE_ERROR = 'CHANGE_STATUS_SALES_INVOICE_ERROR';

export const UPLOAD_SALES_INVOICE_FILES_REQUEST = 'UPLOAD_SALES_INVOICE_FILES_REQUEST';
export const UPLOAD_SALES_INVOICE_FILES_PROGRESS = 'UPLOAD_SALES_INVOICE_FILES_PROGRESS';
export const UPLOAD_SALES_INVOICE_FILES_SUCCESS = 'UPLOAD_SALES_INVOICE_FILES_SUCCESS';
export const UPLOAD_SALES_INVOICE_FILES_ERROR = 'UPLOAD_SALES_INVOICE_FILES_ERROR';

export const DELETE_SALES_INVOICE_FILE_REQUEST = 'DELETE_SALES_INVOICE_FILE_REQUEST';
export const DELETE_SALES_INVOICE_FILE_SUCCESS = 'DELETE_SALES_INVOICE_FILE_SUCCESS';
export const DELETE_SALES_INVOICE_FILE_ERROR = 'DELETE_SALES_INVOICE_FILE_ERROR';

export const DELETE_SALES_INVOICE_REQUEST = 'DELETE_SALES_INVOICE_REQUEST';
export const DELETE_SALES_INVOICE_SUCCESS = 'DELETE_SALES_INVOICE_SUCCESS';
export const DELETE_SALES_INVOICE_ERROR = 'DELETE_SALES_INVOICE_ERROR';

export const CLEAN_SALES_INVOICES = 'CLEAN_SALES_INVOICES';

// Get salesInvoices
export function getSalesInvoices(query) {
    return async (dispatch) => {
        try {
            dispatch(getSalesInvoicesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/sales-invoices/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSalesInvoicesSuccess, getSalesInvoicesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSalesInvoicesError));
        }
    };
}
function getSalesInvoicesRequest() {
    return {
        type: GET_SALES_INVOICES_REQUEST,
        isFetching: true
    };
}
function getSalesInvoicesSuccess (payload) {
    return {
        type: GET_SALES_INVOICES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSalesInvoicesError(errorMessage) {
    return {
        type: GET_SALES_INVOICES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get salesInvoice
export function getSalesInvoice(salesInvoiceId) {

    return async (dispatch) => {
        try {
            dispatch(getSalesInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/sales-invoices/${salesInvoiceId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSalesInvoiceSuccess, getSalesInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSalesInvoiceError));
        }
    };
}
function getSalesInvoiceRequest() {
    return {
        type: GET_SALES_INVOICE_REQUEST,
        isFetching: true
    };
}
function getSalesInvoiceSuccess (payload) {
    return {
        type: GET_SALES_INVOICE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSalesInvoiceError(errorMessage) {
    return {
        type: GET_SALES_INVOICE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create salesInvoice
export function createSalesInvoice(salesInvoice, options) {
    return async (dispatch) => {
        try {
            dispatch(createSalesInvoiceRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/sales-invoices', {salesInvoice, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createSalesInvoiceSuccess, createSalesInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, createSalesInvoiceError));
        }
    };
}
function createSalesInvoiceRequest() {
    return {
        type: CREATE_SALES_INVOICE_REQUEST,
        isFetching: true
    };
}
function createSalesInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for create salesInvoice success
        dispatch(addNotification({
            message: 'Factura añadida correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_SALES_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createSalesInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for create salesInvoice error
        dispatch(addNotification({
            message: 'Error al añadir la factura',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_SALES_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update salesInvoice
export function updateSalesInvoice(salesInvoiceId, salesInvoice = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateSalesInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/sales-invoices/${salesInvoiceId}`, salesInvoice, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateSalesInvoiceSuccess, updateSalesInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateSalesInvoiceError));
        }
    };
}
function updateSalesInvoiceRequest() {
    return {
        type: UPDATE_SALES_INVOICE_REQUEST,
        isFetching: true
    };
}
function updateSalesInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for update salesInvoice success
        dispatch(addNotification({
            message: 'Factura actualizada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_SALES_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateSalesInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for update salesInvoice error
        dispatch(addNotification({
            message: 'Error al actualizar la factura',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_SALES_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change salesInvoice status
export function changeSalesInvoiceStatus(salesInvoiceId, status, options = {}) {
    return async (dispatch) => {
        try {
            dispatch(changeSalesInvoiceStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/sales-invoices/${salesInvoiceId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeSalesInvoiceStatusSuccess, changeSalesInvoiceStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeSalesInvoiceStatusError));
        }
    };
}
function changeSalesInvoiceStatusRequest() {
    return {
        type: CHANGE_STATUS_SALES_INVOICE_REQUEST,
        isFetching: true
    };
}
function changeSalesInvoiceStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_SALES_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changeSalesInvoiceStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_SALES_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload salesInvoice files
export function uploadSalesInvoiceFiles(salesInvoiceId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadSalesInvoiceFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/sales-invoices/${salesInvoiceId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadSalesInvoiceFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadSalesInvoiceFilesSuccess, uploadSalesInvoiceFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadSalesInvoiceFilesError));
        }
    };
}
function uploadSalesInvoiceFilesRequest() {
    return {
        type: UPLOAD_SALES_INVOICE_FILES_REQUEST,
        isFetching: true
    };
}
function uploadSalesInvoiceFilesProgress(percent) {
    return {
        type: UPLOAD_SALES_INVOICE_FILES_PROGRESS,
        percent
    };
}
function uploadSalesInvoiceFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload salesInvoice file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_SALES_INVOICE_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadSalesInvoiceFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload salesInvoice file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_SALES_INVOICE_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download salesInvoice file
export function downloadSalesInvoiceFile(salesInvoiceId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/sales-invoices/${salesInvoiceId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete salesInvoice file
export function deleteSalesInvoiceFile(salesInvoiceId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteSalesInvoiceFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/sales-invoices/${salesInvoiceId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSalesInvoiceFileSuccess, deleteSalesInvoiceFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSalesInvoiceFileError));
        }
    };
}
function deleteSalesInvoiceFileRequest() {
    return {
        type: DELETE_SALES_INVOICE_FILE_REQUEST,
        isFetching: true
    };
}
function deleteSalesInvoiceFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SALES_INVOICE_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteSalesInvoiceFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SALES_INVOICE_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete salesInvoice
export function deleteSalesInvoice(salesInvoiceId) {

    return async (dispatch) => {
        try {
            dispatch(deleteSalesInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/sales-invoices/${salesInvoiceId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSalesInvoiceSuccess, deleteSalesInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSalesInvoiceError));
        }
    };
}
function deleteSalesInvoiceRequest() {
    return {
        type: DELETE_SALES_INVOICE_REQUEST,
        isFetching: true
    };
}
function deleteSalesInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for delete salesInvoice success
        dispatch(addNotification({
            message: 'Factura eliminada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SALES_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteSalesInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for delete salesInvoice error
        dispatch(addNotification({
            message: 'Error al eliminar el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SALES_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean salesInvoices reducer
export function cleanSalesInvoices() {
    return {
        type: 'CLEAN_SALES_INVOICES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/sales-invoices.js